<script setup lang="ts">
// import { useDataStore } from "~~/base/app/stores/data"
// const DataStore = useDataStore()

// useHead({
// 	htmlAttrs: {
// 		class: "scroll-smooth",
// 	},
// })
</script>

<template>
	<div
		style="
			background: url(&quot;/bkg2.png&quot;);
			background-color: #020227;
			background-size: cover;
			background-repeat: no-repeat;
			/* background-position-y: top -45%; */
		"
	>
		<AppHeader />

		<UMain>
			<slot />
		</UMain>

		<AppFooter />
	</div>
</template>
